import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { OnViewerResize } from '../../Viewer/_actions/ViewerActions';
import Store from '../../Store';
import { OnTogglePreviewFabric, OnPreviewFabricSetSize } from '../_actions/ToolsActions';
import PreviewFabric, { Props } from '../_components/PreviewFabric';

const mapStateToProps = (store:Store, props:Props) => ({
	enabled: store.getIn(['create','tools','previewFabric','enabled']),
	fabrics: store.getIn(['UIData', 'fabrics']),
	windowWidth: store.getIn(['create', 'window', 'width']),
	viewerHeight: store.getIn(['create', 'viewer', 'height']),
});

const mapDispatchToProps = (dispatch:Dispatch, props:Props) => ({
	onClick: () => dispatch(OnTogglePreviewFabric()),
	resizeViewer: (width: number, height: number) => dispatch(OnViewerResize(width, height)),
	setSize: (width: number, height: number) => dispatch(OnPreviewFabricSetSize(width, height))
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(PreviewFabric);